
import PropTypes from 'prop-types';
import React from 'react';
import Base from './Base';
import config from './config';

/**
 * Component for displaying text in UI
 */

const Text = ({
  small,
  bold,
  size,
  ...props
}) => {
  const { fontSizes, bold: b } = config;

  return (
    <Base
      {...props}
      tagName="p"
      className="Text"
      baseStyle={{
        fontSize: size || (small ? fontSizes[6] : fontSizes[4]),
        fontWeight: bold ? b : null,
        margin: 0,
      }}
    />
  );
};

Text.propTypes = {
  /** Sets a smaller font size */
  small: PropTypes.bool,
  size: PropTypes.number,
  /** Sets bold font weight */
  bold: PropTypes.bool,
};

export default Text;

